import {
  PredkladatelUpdate as PredkladatelUpdateGenerated,
  PredkladatelUpdateApi,
} from 'elegislativa-frontend-ts-axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import { elegislativaPrefixPath } from '../configuration/apiConfigurationConstants';
import Predkladatel from '../../model/legislativnyMaterial/Predkladatel';

const client = new PredkladatelUpdateApi(apiConfiguration(elegislativaPrefixPath));

const map = (predkladatelUpdated: Predkladatel): PredkladatelUpdateGenerated => ({
  aktualnaPredkladatelskaInstitucia: predkladatelUpdated.organizacia,
  aktualnyPredkladatelUuid: predkladatelUpdated.predkladatel?.uuid,
});

// eslint-disable-next-line import/prefer-default-export
export const updatePredkladatel = async (
  type: string,
  year: number,
  index: number,
  predkladatel: Predkladatel,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.updatePredkladatel(type, year, index, map(predkladatel), headers);
  return {
    responseCode: status,
  };
};
